import { AxiosResponse } from 'axios';
import { UserResponse } from 'Models/User';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

export interface PutUserResponse {
	user: UserResponse;
}

const putUser = async (
	token: string | null,
	user: Omit<UserResponse, 'organization'>,
	userId: number
): Promise<AxiosResponse<PutUserResponse>> => {
	const url = getApiUrl(ApiUrl.UsersUser).replace(':userId', userId.toString());
	const axios = getAxiosInstance(token);
	return axios.put<PutUserResponse>(url, user);
};

export default putUser;
